import { InjectionToken } from '@angular/core';

import { Troubleshooting } from './services/troubleshooting';

export interface TroubleshootingConfig {
  readonly fileStorageUrls: string[];
  readonly healthCheckUrls: string[];
}

export const TROUBLESHOOTING = new InjectionToken<Troubleshooting[]>('TROUBLESHOOTING');
export const TROUBLESHOOTING_CONFIG = new InjectionToken<TroubleshootingConfig>('TROUBLESHOOTING_CONFIG');
